import { combineReducers } from "redux";
import authReducer from "src/reducers/authReducer";
import siteSettingsReducer from "src/reducers/siteReducer";

export default combineReducers({
  auth: authReducer,
  site: siteSettingsReducer,
});
